require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/fn/object/assign.js
// module id = 880
// module chunks = 0